<template>
  <div class="container-fluid row">
    <div class="col-md-12" style="margin: 15px;margin-top: 80px">
      <table class="table table-bordered">
        <thead>
          <tr style="text-align: center">
            <th scope="col" style="background-color: #92d050">ครั้งที่</th>
            <th scope="col" style="background-color: #92d050">จำนวนข้อสอบทั้งหมด</th>
            <th scope="col" style="background-color: #92d050">คะแนน</th>
            <th scope="col" style="background-color: #92d050" v-if="statustime"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="l in list" :key="l.id">
            <td scope="row"><span v-html="l.test_no"></span></td>
            <td scope="row"><span v-html="l.count"></span> ข้อ</td>
            <td scope="row">{{ l.score }}</td>
            <td v-if="statustime">
              <a :href="'/testresult/' + l.test_no">
                <button type="button" class="btn btn-warning btn-sm">
                  <i class="fa fa-eye"></i>
                </button>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import AnswerTrainingService from '../services/AnswerTrainingService';
import AnswerTimesService from '../services/AnswerTimesService';

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      list: [],
      score: 0,
      statustime: false
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.list = [];
      AnswerTrainingService.getTestAnswerStudentsAll(this.currentUser.user_id).then((res) => {
        console.log(res.data);
        this.list = res.data
      })
      AnswerTrainingService.getScoreStudent(this.currentUser.user_id).then((res) => {
        // console.log(res.data);
        this.score = res.data.score
      })
      AnswerTimesService.getAnswerTime().then((res) => {
        // console.log(res.data[0].start_date);
        var dd = res.data[0].start_date
        var ee = res.data[0].end_date
        var now = new Date()
        var start_date = new Date(dd)
        var end_date = new Date(ee)
        start_date = new Date(start_date.getFullYear(),start_date.getMonth(),start_date.getDate(),now.getHours(),now.getMinutes(),0)
        end_date = new Date(end_date.getFullYear(),end_date.getMonth(),end_date.getDate(),now.getHours(),now.getMinutes(),0)
        now = new Date(now.getFullYear(),now.getMonth(),now.getDate(),end_date.getHours(),end_date.getMinutes(),0)
        // var end = dates.getFullYear()+'-'+dates.getMonth()+'-'+dates.getDate() + ' ' +res.data[0].time_end
        // console.log(start_date);
        // console.log(end_date);
        // console.log(now);
        if (now <= end_date) {
          // console.log(1);
          this.statustime = true
        } else if(now > start_date && now < end_date){
          // console.log(2);
          this.statustime = true
        }else {
          this.statustime = false
        }
        // console.log(this.statustime);
      })
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}</style>
